import { render, staticRenderFns } from "./ceGroup.vue?vue&type=template&id=2338900e"
import script from "./ceGroup.vue?vue&type=script&lang=js"
export * from "./ceGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports